import { render, staticRenderFns } from "./NonconformanceHoldTags.vue?vue&type=template&id=0c08a15a"
import script from "./NonconformanceHoldTags.vue?vue&type=script&lang=js"
export * from "./NonconformanceHoldTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports